import React from "react";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";

import { makeStyles } from "@mui/styles"; // Modification ici
// import { Tooltip } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 0,
    border: "0px solid red",
    "& .MuiTextField-root": {
      margin: 1,
    },
  },
  platformTitle: {
    marginTop: 20,
    marginBottom: 20,
  },
  marginRight: {
    marginRight: 10,
  },
  fullWidth: { width: "100%" },
  extraMarginTop: {
    marginTop: 20,
  },
  categories: {
    marginTop: 20,
    marginBottom: 20,
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
    padding: "10px 0",
  },
  platforms: {
    margin: "20px 0",
  },
}));

const AdminPayment = (props) => {
  const {
    name,
    account,
    owner,
    submitting,
    stripe_payout_amount,
    stripe_payout_currency,
    stripe_payout_id,
    stripe_payout_status,
    onNameChange,
    onAccounthange,
    onOwnerNameChange,
    onPostItem,
    onCancelAction,
  } = props;

  const styles = {
    root: {
      marginTop: 1,
    },
  };

  const classes = useStyles();

  return (
    <React.Fragment>
      <form noValidate autoComplete="off" style={styles.root}>
        {/* <FormControl fullWidth>
          <TextField
            label="Institution financière"
            margin="normal"
            onChange={onNameChange}
            variant="outlined"
            value={name}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="IBAN"
            margin="normal"
            onChange={onAccounthange}
            variant="outlined"
            value={account}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="Nom & prénom du propriétaire"
            margin="normal"
            onChange={onOwnerNameChange}
            variant="outlined"
            value={owner}
          />
        </FormControl> */}

        <FormControl fullWidth>
          <TextField
            label="Montant"
            margin="normal"
            variant="outlined"
            value={stripe_payout_amount}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="Devise"
            margin="normal"
            variant="outlined"
            value={stripe_payout_currency}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="Payout ID"
            margin="normal"
            variant="outlined"
            value={stripe_payout_id}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            label="Status"
            margin="normal"
            variant="outlined"
            value={stripe_payout_status}
          />
        </FormControl>
      </form>
      <FormControl fullWidth></FormControl>
      <div className={classes.actions}>
        <Button variant="contained" disabled={submitting} onClick={onPostItem}>
          {submitting ? "processing ..." : "Sauver"}
        </Button>
        <Button
          variant="contained"
          disabled={submitting}
          onClick={onCancelAction}
        >
          Annuler
        </Button>
      </div>
    </React.Fragment>
  );
};

export default AdminPayment;
